module.exports = __webpack_public_path__ + "static/media/myfi.a0bea633.png";